var lib_core = require("lib-core");

var PosAngleData = require("./../../abstract/posAngleData.js");

var SchematicElementData = require("./schematicElementData.js");

var SymbolTerminalData = require("./../../symbol/symbolTerminalData.js");
var SchematicLabelTerminal = require("./schematicLabelTerminal.js");

var SchematicNetLabelData = function(pos, angle, label, symbolDescription) {
    var self = this;

    this.registerInstanceClass(["terminals"], SymbolTerminalData, SchematicLabelTerminal);
    lib_core.InstanceBuilder.call(this, symbolDescription);

    this.addPosAngle(pos, angle);
    this.label = this.value("label", true);

    this.nonTransformedBoundingBox = this.cachedFunction("nonTransformedBoundingBox",
        function(){
            var boundingBox = null;
            self.description().shapes.forEach(function(index, element){
                var elementBB = element.boundingBox && element.boundingBox();
                if (elementBB) boundingBox = elementBB.merge(boundingBox);
            });
            self.description().generators.forEach(function(generator) {
                var generatorBB = generator.boundingBox && generator.boundingBox();
                if (generatorBB) boundingBox = generatorBB.merge(boundingBox);
            });
            return boundingBox;
        },
        [[this, this.onBubble]]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var bb = self.nonTransformedBoundingBox();
            return bb.rotate(self.angle())
                     .translate(self.pos());
        },
        [[this, this.onBubble]]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(){
            return self.boundingBox().getPoly();
        },
        [[this, this.onBubble]]
    );

    if(label !== undefined) this.label(label);
};
lib_core.inherit(SchematicNetLabelData, lib_core.InstanceBuilder);
lib_core.mixin(SchematicNetLabelData, PosAngleData);
lib_core.JsonParser.registerClass(SchematicNetLabelData, "SchematicNetLabelData");

SchematicNetLabelData.prototype.net = function () {
    return this.terminals.getOne().net();
};

var SchematicGndLabelData = function() {
    SchematicNetLabelData.apply(this, arguments);
};
lib_core.inherit(SchematicGndLabelData, SchematicNetLabelData);
lib_core.JsonParser.registerClass(SchematicGndLabelData, "SchematicGndLabelData");

var SchematicVccLabelData = function() {
    SchematicNetLabelData.apply(this, arguments);
};
lib_core.inherit(SchematicVccLabelData, SchematicNetLabelData);
lib_core.JsonParser.registerClass(SchematicVccLabelData, "SchematicVccLabelData");

module.exports.SchematicNetLabelData = SchematicNetLabelData;
module.exports.SchematicVccLabelData = SchematicVccLabelData;
module.exports.SchematicGndLabelData = SchematicGndLabelData;

